import { Button, Grid, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import pendingBanner from "../../../../assets/payment_pending_banner.svg"
import { MembershipPaymentAcknowledgementPageProps } from "../../../../views/arrears-payment-flow/AcknowledgementPage/AcknowledgementPage"
import { ArrearsRoute } from "../../../../views/arrears-payment-flow/ArrearsPaymentFlow/ArrearsPaymentFlow"
import PaymentAcknowledgementBanner from "../../PaymentAcknowledgementBanner"

const MembershipPaymentPending = (props: MembershipPaymentAcknowledgementPageProps) => {
    const { orderId, onNavigateTo } = props
    const { t } = useTranslation(`arrears-payment`)

    const handleHomeClick = () => {
        if (window.myNtucConfig.paymentBackToHomeHomeUrl != undefined) {
            window.location.replace(window.myNtucConfig.paymentBackToHomeHomeUrl)
        } else {
            onNavigateTo(ArrearsRoute.Main)
        }
    }

    return (
        <Grid rowSpacing={3} container justifyContent="center" padding={2}>
            <PaymentAcknowledgementBanner bannerUrl={pendingBanner} alt="Payment pending banner" />
            <Grid item justifyContent="center" xs={12}>
                <Typography textAlign="center" variant="h2">{t(`paymentIsPending`)}</Typography>
            </Grid>
            <Grid item justifyContent="center" xs={12}>
                <Typography textAlign="center">{t(`arrearPaymentIsPending`)}</Typography>
            </Grid>
            <Grid item justifyContent="center" xs={12}>
                <Typography color="text.secondary" textAlign="center">{t(`reference`)}</Typography>
                <Typography textAlign="center" data-testid="reference">{orderId}</Typography>
            </Grid>
            <Grid container item xs={12} sm={12} md={6} lg={6} mt={3} justifyContent='center'>
                <Button onClick={handleHomeClick} variant="contained" color="secondary" size="large" sx={{ marginX: 5, marginY: 1 }}>
                    {t(`home`)}
                </Button>
            </Grid>
        </Grid>
    )
}

export default MembershipPaymentPending